import { alpha } from '@mui/material';
import { clamp } from '@ui/style/clamp-calculator';
import { between } from '@ui/style/style';
import { useResponsive } from '@ui/style/useResponsive';
import { headerHeight, spaceAboveHeader, spaceBelowHeader } from '@ui/style/variables';
const usePeopleStyles = () => {
    const { isMobile } = useResponsive();
    const headingHeight = 38;
    const cardContainerHeight = `${spaceAboveHeader + headerHeight + spaceBelowHeader + headingHeight}px`;
    return {
        main: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4.25,
            overflowY: 'hidden'
            // px: isMobileIpadNavigation ? 0 : clamp.calculate(8, 32)
        },
        contentContainer: {
            flexGrow: 1,
            px: isMobile ? 1 : undefined,
            overflowY: 'auto'
            // py: 1
            // maxHeight: isMobileIpadNavigation ? `calc(100dvh -  ${cardContainerHeightMobile})` : undefined
        },
        mobileScreenHeader: {
            between,
            flexDirection: 'row',
            backgroundColor: (theme) => alpha(theme.palette.common.black, 0.2),
            px: clamp.calculate(8, 32),
            height: '100%'
        },
        mobileScreenHeadingButton: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            alignItems: 'center'
        },
        gridItem: {
            height: `calc(100dvh - ${cardContainerHeight})`
        },
        container: {
            height: '100%',
            p: 2
        },
        gridContainer: {
            height: '100%'
        },
        activityFramesContainer: {
            display: 'flex',
            height: '100%',
            flexDirection: 'column',
            gap: 2
        },
        cardSection: {
            backgroundColor: alpha('#25292D', 0.3),
            borderRadius: 4,
            backdropFilter: 'blur(10px)'
        }
    };
};
export default usePeopleStyles;
